import React from 'react';
import GenericForm from '../GenericForm';

interface ITreesFormProps {
  meta: any;
  conditions?: any;
  data: any;
  onSubmit: (data: any) => Promise<any>;
  onClose?: () => void;
}

const TreesForm = (props: ITreesFormProps) => {
  return <GenericForm {...props} entityName={'notes'} title={'Trees'} />;
};

export default React.memo(TreesForm);
